module.exports = __webpack_public_path__ + "img/base_class_ban.77822720.png";